const isOauthMethod = (method)=>method.endsWith('_oauth');

export { isOauthMethod };
//# sourceMappingURL=isOauthMethod.mjs.map
